<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_ix"></a>CONTENTS</h2>
<p class="toc-1"><a class="none" href="#/xhtml/preface"><span class="smallcaps">PREFACE</span></a></p>
<p class="toc-1"><a class="none" href="#/xhtml/acknowledgments"><span class="smallcaps">ACKNOWLEDGMENTS</span></a></p>
<p class="toc-1"><a class="none" href="#/xhtml/note_spelling"><span class="smallcaps">NOTE ON SPELLING AND ORTHOGRAPHY</span></a></p>
<p class="toc-1"><a class="none" href="#/xhtml/abbreviations"><span class="smallcaps">LIST OF ABBREVIATIONS</span></a></p>
<p class="toc-n"><a class="none" href="#/xhtml/chapter_01">1 Prelude</a></p>
<p class="toc"><a class="none" href="#/xhtml/chapter_02">2 Assembly: Logooli Historical, Cultural, and Musical Background</a></p>
<p class="toc"><span class="none" href="#/xhtml/chapter_03" title="Link target outside of Sample">3 Encounter: Avalogooli and Euro-American Religion, Culture, and Music</span></p>
<p class="toc"><span class="none" href="#/xhtml/chapter_04" title="Link target outside of Sample">4 Consolidation: Christian Religious Genres in Logooli-Land</span></p>
<p class="toc"><span class="none" href="#/xhtml/chapter_05" title="Link target outside of Sample">5 Accommodation: Logooli Adoption and Use of ‘Book’ Music</span></p>
<p class="toc"><span class="none" href="#/xhtml/chapter_06" title="Link target outside of Sample">6 Syncretism: Logooli Christian Songs of the Spirit</span></p>
<p class="toc"><span class="none" href="#/xhtml/chapter_07" title="Link target outside of Sample">7 Invocation: Logooli Christian Songs in Contemporary Education and Media</span></p>
<p class="toc-nb"><span class="none" href="#/xhtml/chapter_08" title="Link target outside of Sample">8 Epilogue</span></p>
<p class="toc-1"><span class="none" href="#/xhtml/appendix_1" title="Link target outside of Sample"><span class="smallcaps">APPENDIX 1</span>. Archival and Media House Records</span></p>
<p class="toc-1"><span class="none" href="#/xhtml/appendix_2" title="Link target outside of Sample"><span class="smallcaps">APPENDIX 2</span>. Song Text and Hymn Tune Sources</span></p>
<p class="toc-1"><span class="none" href="#/xhtml/glossary" title="Link target outside of Sample"><span class="smallcaps">GLOSSARY OF TERMS</span></span></p>
<p class="toc-1"><span class="none" href="#/xhtml/notes" title="Link target outside of Sample"><span class="smallcaps">NOTES</span></span></p>
<p class="toc-1"><span class="none" href="#/xhtml/bibliography" title="Link target outside of Sample"><span class="smallcaps">BIBLIOGRAPHY</span></span></p>
<p class="toc-1"><span class="none" href="#/xhtml/index" title="Link target outside of Sample"><span class="smallcaps">INDEX</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?019aa884